import { defaultSchema } from "rehype-sanitize";

// rehype-raw lets the markdown renderers interpret raw HTML embedded in AI- or
// user-influenced content, which is an XSS sink. This schema runs rehype-sanitize after
// rehype-raw to strip scripts, event handlers and javascript: URLs while extending the
// default (GitHub-like) allow-list with the app's internal "artefact://" link protocol so
// inline artefact links keep working.
export const markdownSanitizeSchema = {
  ...defaultSchema,
  protocols: {
    ...defaultSchema.protocols,
    href: [...(defaultSchema.protocols?.href ?? []), "artefact"],
  },
};
